import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { AddDeviceForm, DevicesDescriptionForm, UpdateDeviceForm } from "./api";
import {
  addDevice,
  createQRDevice,
  getDeviceMessages,
  getDevices,
  getDevicesSmall,
  updateDevice,
} from "./slice";

export const useDevices = () => {
  const state = useAppSelector((state) => state.device);
  const methods = useDevicesDispatch();

  return {
    state,
    ...methods,
  };
};

export const useDevicesDispatch = () => {
  const userId = useUserId();
  const dispatch = useAppDispatch();

  const getDevicesHandler = useCallback(
    (data: DevicesDescriptionForm) => dispatch(getDevices({ userId, data })),
    [dispatch, userId]
  );

  const getDeviceMessagesHandler = useCallback(
    (deviceId: string) => dispatch(getDeviceMessages({ userId, deviceId })),
    [dispatch, userId]
  );

  const addDeviceHandler = useCallback(
    (data: AddDeviceForm) => dispatch(addDevice({ userId, data })),
    [dispatch, userId]
  );

  const createQRDeviceHandler = useCallback(
    () => dispatch(createQRDevice({ userId })).unwrap(),
    [dispatch, userId]
  );

  const updateDeviceHandler = useCallback(
    (data: UpdateDeviceForm) => dispatch(updateDevice({ userId, data })),
    [dispatch, userId]
  );

  const getDevicesSmallHandler = useCallback(
    () => dispatch(getDevicesSmall({ userId })),
    [dispatch, userId]
  );

  return {
    getDevices: getDevicesHandler,
    getDeviceMessages: getDeviceMessagesHandler,
    addDevice: addDeviceHandler,
    updateDevice: updateDeviceHandler,
    getDevicesSmall: getDevicesSmallHandler,
    createQRDevice: createQRDeviceHandler,
  };
};
